<template>
    <div class="container">
        <h4 class="title is-4">Debug Topic Family {{topicFamily}}</h4>
        <b-table
                v-if="data.length > 0"
                :narrowed="true"
                :striped="true"
                default-sort="topic"
                :data="data"
        >
            <template slot-scope="props">
                <b-table-column label="Topic" field="topic" sortable>{{props.row.topic}}</b-table-column>
                <b-table-column label="Value" field="value" numeric>
                    <app-topic-value :topic="props.row.topic"></app-topic-value>
                </b-table-column>
            </template>
        </b-table>
        <div v-else>No data collected.</div>
    </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import TopicValue from '../components/TopicValue';

  export default {
    name: "screendebugtopicfamily",
    props: ['index'],
    components: {
      appTopicValue: TopicValue
    },
    computed: {
      ...mapGetters('mqtt', ['topicFamilies', 'mapping']),
      topicFamily() {
        return this.topicFamilies[this.index];
      },
      data() {
        const ret = [];
        Object.keys(this.mapping).forEach(topic => {
          if (topic.startsWith(this.topicFamily.replace(/#/, ''))) {
            ret.push({
              topic: topic,
              value: this.mapping[topic]
            });
          }
        });
        return ret;
      }
    }
  }
</script>

<style scoped>

</style>